import { RegionTypes } from './regions';
import { RegionService } from '../services/regionService';

const IS_SA = new RegionService().currentRegion() === RegionTypes.SaudiArabia;
const isArabic = localStorage.getItem('i18nextLng') === 'ar';

const CYNOPSIS_URL = process.env.REACT_APP_CYNOPSIS_URL;
const WEBSITE_URL = `${process.env.REACT_APP_WEBSITE_URL}${IS_SA ? 'sa' : 'ae'
	}/`;
const IS_PROD = process.env.REACT_APP_ENV === 'prod';
const OTP_TIMEOUT = 60;
const MIN_INVESTMENT = 10;

const API_KEY = IS_SA
	? process.env.REACT_APP_API_URL_SA
	: process.env.REACT_APP_API_URL;
const CURRENCY = IS_SA
	? !isArabic ? process.env.REACT_APP_CURRENCY_SA : process.env.REACT_APP_CURRENCY_SA_AR
	: !isArabic ? process.env.REACT_APP_CURRENCY : process.env.REACT_APP_CURRENCY_AR;
const SOUQ_BANK_DETAILS = {
	souqBankName: IS_SA
		? process.env.REACT_APP_SOUQ_BANK_NAME_SA
		: process.env.REACT_APP_SOUQ_BANK_NAME,
	souqBankAddress: IS_SA
		? process.env.REACT_APP_SOUQ_BANK_ADDRESS_SA
		: process.env.REACT_APP_SOUQ_BANK_ADDRESS,
	souqAccountName: IS_SA
		? process.env.REACT_APP_SOUQ_ACCOUNT_NAME_SA
		: process.env.REACT_APP_SOUQ_ACCOUNT_NAME,
	souqIBAN: IS_SA
		? process.env.REACT_APP_SOUQ_IBAN_SA
		: process.env.REACT_APP_SOUQ_IBAN,
	souqSwiftCode: IS_SA
		? process.env.REACT_APP_SOUQ_SWIFT_CODE_SA
		: process.env.REACT_APP_SOUQ_SWIFT_CODE,
	souqAccountNumber: IS_SA
		? process.env.REACT_APP_SOUQ_ACCOUNT_NUMBER_SA
		: process.env.REACT_APP_SOUQ_ACCOUNT_NUMBER,
	abaRoutingNumber: IS_SA
		? process.env.REACT_APP_SOUQ_ABA_ROUTING_NUMBER_SA
		: process.env.REACT_APP_SOUQ_ABA_ROUTING_NUMBER,
};

const BASE_URLS = {
	en: process.env.REACT_APP_BASE_URL_EN,
	sa: process.env.REACT_APP_BASE_URL_SA,
};

const CURRENT_ENV = process.env.REACT_APP_TEST_ENV;

const OPENPANEL_CLIENT_ID = process.env.REACT_APP_OPENPANEL_CLIENT_ID;
const OPENPANEL_API_URL = process.env.REACT_APP_OPENPANEL_API_URL;

const CUSTOMERIO_WRITE_KEY = process.env.REACT_APP_CUSTOMERIO_WRITE_KEY;
const CUSTOMERIO_CDN_URL = process.env.REACT_APP_CUSTOMERIO_CDN_URL;

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;

const RECAPTCHA_SITE_KEY = '6LfaTO4tAAAAAGATjyt667jBl9QizlSgto5n0oFs';

const OLD_APP_URL = IS_SA
	? process.env.REACT_APP_OLD_APP_URL_SA
	: process.env.REACT_APP_OLD_APP_URL_EN;

export {
	API_KEY,
	CYNOPSIS_URL,
	WEBSITE_URL,
	CURRENCY,
	IS_SA,
	IS_PROD,
	SOUQ_BANK_DETAILS,
	OTP_TIMEOUT,
	MIN_INVESTMENT,
	BASE_URLS,
	OLD_APP_URL,
	CURRENT_ENV,
	OPENPANEL_CLIENT_ID,
	OPENPANEL_API_URL,
	CUSTOMERIO_WRITE_KEY,
	CUSTOMERIO_CDN_URL,
	GOOGLE_CLIENT_ID,
	RECAPTCHA_SITE_KEY,
	APPLE_CLIENT_ID,
	APPLE_REDIRECT_URI
};
